import {useRouteTemplates} from "hooks/useRouteTemplates";
import {useSetting} from "../../contexts/setting";
import cn from "classnames";
import TemplateControls from "../../layout/TemplateControls";
import SortableList from "../../layout/SortableList";

const Events = () => {
  const {visible, currentVideoPopup} = useSetting();

  // Without the banners an admin removed (libs/bannerComposition.ts).
  const filteredTemplates = useRouteTemplates("events");
  const bannerIds = filteredTemplates.map((template) => template.id);
  const hasOnlyOneBanner = bannerIds.length === 1;

  return (
    <SortableList
      items={filteredTemplates}
      useDragHandle={true}
      getItemClassName={(item) =>
        cn("template-wrap", {
          hidden: !hasOnlyOneBanner && !visible.some((x) => x === item.id),
          popup: currentVideoPopup === item.id,
        })
      }
      renderItem={(item, {listeners, attributes} = {}) => (
        <>
          <div
            className="template-annotation"
            {...(listeners || {})}
            {...(attributes || {})}
            style={{cursor: "grab"}}
          >
            <span className="label">{`${item.label} (${item.dimensions}${item.suffix || ""})`}</span>
            <TemplateControls
              id={item.id}
              templateChannel="events"
              hasOnlyOneBanner={hasOnlyOneBanner}
              bannerIds={bannerIds}
            />
          </div>
          {item.getComponent()}
        </>
      )}
    />
  );
};

export default Events;
